const countries = [
  {
    codigo: 'CHL',
    pais: 'Chile'
  },
  {
    codigo: 'PER',
    pais: 'Perú'
  },
  {
    codigo: 'COL',
    pais: 'Colombia'
  },
  {
    codigo: 'BOL',
    pais: 'Bolivia'
  },
  {
    codigo: 'GNQ',
    pais: 'Guinea Ecuatorial'
  },
]
export default countries


// WEBPACK FOOTER //
// ./src/App/Root/countries.js